/* Loads the legacy screens' own scripts the first time they're used
 * (performance audit fix 9), instead of on every page.
 *
 *   People panel (pp-people.js)          every page: when PPPeople.open() or .mount() is first called
 *   Calendar (pp-calendar.js + css)      every page: the project menu's Calendar, or the Overview
 *     (+ pp-subscribe.js, its Subscribe button; People's Booking uses it too)
 *   Crew and cast (pp-crew.js + css)     storyboard shell: People in the side bar, or a /people address
 *   Locations (pp-locations.js + css)    storyboard shell: Locations in the side bar, or a /locations address
 *   Prep (pp-prep.js + css)              storyboard shell: Prep in the side bar, or a /prep address
 *   Schedule (pp-schedule.js + css)      storyboard shell: Schedule in the side bar (or More on a phone), or a
 *                                        /schedule address
 *   Budget (pp-budget.js + css)          storyboard shell: the Budget button, a /budget address, or
 *                                        expenses still waiting to send from an earlier visit
 *   Script (script-handler.js + css,     storyboard shell: Script, or the Shot Editor (its script context)
 *     its play-through, pp-playthrough.js + css, and What changed, pp-script-compare.js + css)
 *   Set Pieces (sb-set-pieces.js)        storyboard shell: Set Pieces, its address, or a notification about one
 *   Scout photos (pp-scout.js + css)     every page: a Scout photos button (the camera and compass are
 *                                        asked for in that same tap), or photos still waiting to upload
 *   Address search (pp-address.js)      the building editor: Where it is (Locations loads it with its own)
 *   Floor plan PDF reader               the building editor: Import plan with a PDF (pp-plan-pdf.js;
 *     (pp-plan-pdf.js)                   pdf.js itself loads from /vendor/)
 *   Call sheets (production-call-sheets.js)  the board: Call Sheet, a call on the timeline, or a
 *                                        couple of seconds after the board opens for someone who
 *                                        manages days on a wide screen (it shows them pending updates)
 *
 * Until a file arrives, its global (PPPeople, PPCrew, PPLocations, PPSchedule,
 * PPBudget, ProductionCallSheets) is a stand-in marked __lazy that loads it and then
 * passes the call on; the real file replaces it. Stylesheets load before the
 * script runs, so nothing draws unstyled.
 */
(function () {
  'use strict';
  if (window.PPLazy) return;
  // Each file's content version, filled in at build (stamp-legacy.mjs).
  var VERSIONS = {"account-panel.css":"55b3913300","account-panel.js":"cceb9de46d","catalog-shim.js":"d179142495","design/theme-app.css":"f08ccb51b2","design/tokens.css":"7452f28559","offline-queue.js":"4042431f3f","pp-address.js":"0bfe5b328e","pp-board.css":"ebed422068","pp-brand.css":"224d85e073","pp-budget.css":"57ab242828","pp-budget.js":"07932fe991","pp-calendar.css":"e14055f5e6","pp-calendar.js":"f9ccc16f6f","pp-callsheet.css":"acf6993af4","pp-consistency.css":"dd2f3733ee","pp-crew-day.css":"6098f23d8d","pp-crew-day.js":"e1846752e8","pp-crew-prep.css":"6edbc412a9","pp-crew-prep.js":"4c9cd5e2e9","pp-crew.css":"455b5d77dd","pp-crew.js":"41adb60fb5","pp-days.js":"cbeeb727d5","pp-dept-sample.js":"b9fd897314","pp-dept-views.js":"e339db368c","pp-dept.css":"0187219256","pp-dept.js":"4134a2ff51","pp-editor.css":"cf5f03eb5e","pp-exposure.js":"ae75cdc0dd","pp-header.css":"e08ae9d9e6","pp-header.js":"d1d77690c2","pp-light.js":"edd98b9705","pp-link-add.js":"d32999af5c","pp-live.js":"f58dd76920","pp-locations.css":"b714e6eda5","pp-locations.js":"4af6a6cd28","pp-maps.js":"2df3a2900e","pp-overview.js":"874dbe4b6d","pp-pdf-map.css":"e53b6c970c","pp-pdf-map.js":"c40d070014","pp-people.js":"8a41e1b2c4","pp-phone.css":"a5bdb09574","pp-phone.js":"00c39c7b34","pp-plan-pdf.js":"48e43292c3","pp-plan.js":"ee60dc4562","pp-playthrough.css":"8b75326a35","pp-playthrough.js":"775e07fe57","pp-power.js":"2bbc1afd4a","pp-pre.css":"8d052a3133","pp-prep.css":"ccd6876778","pp-prep.js":"fb43f01584","pp-public.css":"666b3755b5","pp-public.js":"6c364873e0","pp-route.js":"126b83bc27","pp-schedule.css":"9501ec2c31","pp-schedule.js":"a4cd64ae5b","pp-scout.css":"4880bd9e75","pp-scout.js":"8b533874ad","pp-script-compare.css":"43f7cfc9cd","pp-script-compare.js":"00bcaf7ee0","pp-share.js":"032b53c1c1","pp-shell.js":"922f998997","pp-site.js":"389487ca48","pp-subscribe.js":"7c99082960","pp-sun.js":"36e63fecf1","pp-system.css":"b9d2643fcc","pp-tabs.js":"0b6704bf02","pp-ui.css":"d606851001","pp-week.css":"3aa870644c","pp-week.js":"f5a977c7f0","production-call-sheets.css":"3c190eb357","production-call-sheets.js":"bddac65c8f","production-checkin-ui.js":"86126ec7af","production-contacts.css":"d01d30e330","production-contacts.js":"190569c8bd","production-context-menu.js":"08a66f6281","production-people-fields.js":"f1532a5217","production-qr-scan.js":"437790a0a4","production-qr.js":"0e8f5ad744","production-take-frames.js":"32b14c4d6a","production-toast.js":"24e21e9cec","production.css":"d6c182d531","production.js":"8a7e0a130d","sb-capture.js":"cdf24180e2","sb-set-pieces.js":"cc554d2686","script-handler.css":"8a606d3a51","script-handler.js":"4a8b75f611","storyboard.css":"abf5dc182f","storyboard.js":"5c84c4b61b"};
  var BUNDLES = {
    people: { css: [], js: ['pp-people.js'] },
    calendar: { css: ['pp-calendar.css', 'pp-week.css'], js: ['pp-subscribe.js', 'pp-sun.js', 'pp-week.js', 'pp-calendar.js'] },
    // The week by the hour (pp-week.js, with pp-sun.js for night): the project calendars bring it along; My schedule and Spaces load it here.
    week: { css: ['pp-week.css'], js: ['pp-sun.js', 'pp-week.js'] },
    crew: { css: ['pp-crew.css', 'pp-crew-prep.css'], js: ['pp-subscribe.js', 'pp-crew-prep.js', 'pp-crew.js'] },
    budget: { css: ['pp-crew.css', 'pp-budget.css'], js: ['pp-budget.js'] },
    locations: { css: ['pp-crew.css', 'pp-locations.css'], js: ['pp-address.js', 'pp-locations.js'] },
    prep: { css: ['pp-crew.css', 'pp-prep.css'], js: ['pp-prep.js'] },
    address: { css: [], js: ['pp-address.js'] },
    schedule: { css: ['pp-crew.css', 'pp-schedule.css'], js: ['pp-schedule.js'] },
    script: { css: ['script-handler.css', 'pp-playthrough.css', 'pp-script-compare.css'], js: ['script-handler.js', 'pp-playthrough.js', 'pp-script-compare.js'] },
    setpieces: { css: [], js: ['sb-set-pieces.js'] },
    callsheets: { css: [], js: ['production-call-sheets.js'] },
    scout: { css: ['pp-scout.css'], js: ['pp-scout.js'] },
    planpdf: { css: [], js: ['pp-plan-pdf.js'] },
  };

  // Where each stylesheet sat in storyboard.html: later sheets (pp-pre.css
  // restyles the Script screen) must still win over it.
  var AFTER = { 'script-handler.css': 'production-contacts.css', 'pp-crew.css': 'pp-pre.css', 'pp-budget.css': 'pp-crew.css', 'pp-locations.css': 'pp-crew.css', 'pp-prep.css': 'pp-crew.css', 'pp-schedule.css': 'pp-crew.css' };

  function url(name) { return '/legacy/' + name + (VERSIONS[name] ? '?v=' + VERSIONS[name] : ''); }
  var files = {}, bundles = {};
  function css(name) {
    return files[name] || (files[name] = new Promise(function (done) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = url(name);
      l.onload = l.onerror = function () { done(); };
      var at = AFTER[name] && document.querySelector('link[rel="stylesheet"][href^="/legacy/' + AFTER[name] + '"]');
      if (at) at.parentNode.insertBefore(l, at.nextSibling); else document.head.appendChild(l);
    }));
  }
  // A script that runs after the page's load event never sees it, and the
  // legacy screens start from a 'load' handler: hold those and run them as
  // soon as the script is in (boot.js does the same for the storyboard).
  var held = [], holding = 0, realAdd = window.addEventListener;
  function holdLoad() {
    if (holding++) return;
    window.addEventListener = function (type, fn, opts) { if (type === 'load' && fn) { held.push(fn); return; } return realAdd.call(window, type, fn, opts); };
  }
  function releaseLoad() {
    if (!--holding) window.addEventListener = realAdd;
    var ev = new Event('load'), run = held.splice(0);
    run.forEach(function (fn) { try { if (typeof fn === 'function') fn.call(window, ev); else fn.handleEvent(ev); } catch (e) { setTimeout(function () { throw e; }); } });
  }
  function js(name) {
    return files[name] || (files[name] = new Promise(function (done, fail) {
      var s = document.createElement('script'), late = document.readyState === 'complete';
      s.src = url(name); s.async = false;
      if (late) holdLoad();
      s.onload = function () { if (late) releaseLoad(); done(); };
      s.onerror = function () { if (late) releaseLoad(); delete files[name]; fail(new Error(name)); };
      document.body.appendChild(s);
    }));
  }
  function load(key) {
    if (bundles[key]) return bundles[key];
    var b = BUNDLES[key];
    // Fetch the script alongside its stylesheets; run it once they're in.
    b.js.forEach(function (n) { if (!files[n]) { var l = document.createElement('link'); l.rel = 'preload'; l.as = 'script'; l.href = url(n); document.head.appendChild(l); } });
    var p = Promise.all(b.css.map(css)).then(function () { return b.js.reduce(function (q, n) { return q.then(function () { return js(n); }); }, Promise.resolve()); });
    p.catch(function () { delete bundles[key]; });
    return (bundles[key] = p);
  }
  function failed() {
    var n = document.createElement('div');
    n.setAttribute('role', 'alert');
    n.textContent = 'That part of ProProduction couldn’t load. Check your connection and try again.';
    n.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;max-width:calc(100% - 32px);padding:12px 16px;border-radius:10px;background:#3a1d1d;color:#fff;font:14px/1.4 Inter,system-ui,sans-serif;box-shadow:0 6px 24px rgba(0,0,0,.4)';
    document.body.appendChild(n);
    setTimeout(function () { n.remove(); }, 5000);
  }
  // Calls method on the real global once its file is in.
  function later(key, global, method) {
    return function () {
      var args = arguments;
      return load(key).then(function () {
        var g = window[global];
        if (g && !g.__lazy && typeof g[method] === 'function') return g[method].apply(g, args);
      }, failed);
    };
  }
  window.PPLazy = { load: load };

  // On set the signal comes and goes. Once the page has been idle a while,
  // fetch these screens' files into the browser's cache (not parsed or run),
  // so a screen first opened with no signal still opens. Not with Save-Data.
  function prefetchLater(keys) {
    if (navigator.connection && navigator.connection.saveData) return;
    var go = function () {
      keys().forEach(function (key) {
        if (bundles[key]) return;
        BUNDLES[key].css.concat(BUNDLES[key].js).forEach(function (n) {
          if (files[n] || document.querySelector('link[rel="prefetch"][href="' + url(n) + '"]')) return;
          var l = document.createElement('link'); l.rel = 'prefetch'; l.href = url(n); document.head.appendChild(l);
        });
      });
    };
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1); };
    var start = function () { setTimeout(function () { idle(go, { timeout: 10000 }); }, 10000); };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  }

  // People panel: everywhere.
  if (!window.PPPeople) window.PPPeople = { __lazy: true, open: later('people', 'PPPeople', 'open'), mount: later('people', 'PPPeople', 'mount'), mounted: function () { return false; }, close: function () {} };
  // The calendar: everywhere (the project menu), and the Overview.
  if (!window.PPCalendar) window.PPCalendar = { __lazy: true, open: later('calendar', 'PPCalendar', 'open'), mount: later('calendar', 'PPCalendar', 'mount'), close: function () {} };
  // Scout photos: everywhere (the phone's Today, a location's card, the live board). The camera and
  // the compass are asked for in the tap itself (iOS shows its compass prompt only then) while the
  // file comes in. Photos kept on an earlier visit and not uploaded yet bring it in to send them.
  if (!window.PPScout) {
    var scoutAsk = function () {
      var pre = {};
      // As pp-scout.js asks for it.
      try { if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) pre.stream = navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: { ideal: 'environment' }, width: { ideal: 1920 }, height: { ideal: 1440 } } }); } catch (_e) {}
      try { if (window.DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission === 'function') pre.compass = DeviceOrientationEvent.requestPermission(); } catch (_e) {}
      if (pre.stream) pre.stream.catch(function () {});
      if (pre.compass) pre.compass.catch(function () {});
      return pre;
    };
    window.PPScout = { __lazy: true, waiting: function () { return 0; }, addFiles: later('scout', 'PPScout', 'addFiles'), map: later('scout', 'PPScout', 'map'),
      open: function (opts) {
        var pre = scoutAsk();
        return load('scout').then(function () { return window.PPScout.open(opts, pre); }, function () {
          if (pre.stream) pre.stream.then(function (s) { s.getTracks().forEach(function (x) { x.stop(); }); }, function () {});
          failed();
        });
      } };
    try { if (Number(localStorage.getItem('pp-scout-waiting')) > 0) load('scout'); } catch (_e) {}
  }

  var path = function () { return window.PPRoute && window.PPRoute.initial ? window.PPRoute.initial.split('?')[0] : location.pathname; };

  // ── The storyboard shell ──────────────────────────────────────────────
  if (document.getElementById('appScreen')) {
    // Crew and cast. pp-crew.js opens itself from the address when it runs.
    if (!window.PPCrew) window.PPCrew = { __lazy: true, open: later('crew', 'PPCrew', 'open'), show: later('crew', 'PPCrew', 'show'), hide: function () {}, refresh: function () {} };
    if (/^\/[^/]+\/people(\/[^/?#]+)?\/?$/.test(path())) load('crew');
    // Phones: the side bar is folded away, so People gets a button in the
    // bottom bar too (before Budget, as in the side bar).
    var peopleButton = function () {
      var nav = document.getElementById('mobileCompanionNav');
      if (!nav || document.getElementById('ppCrewMobileBtn')) return;
      var rail = document.querySelector('#navShareBtn svg');
      var m = document.createElement('button');
      m.className = 'mobile-nav-btn'; m.id = 'ppCrewMobileBtn'; m.type = 'button';
      m.setAttribute('aria-label', 'People'); m.title = 'People';
      m.innerHTML = rail ? rail.outerHTML : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>';
      nav.insertBefore(m, document.getElementById('ppBudgetMobileBtn') || nav.querySelector('[data-mobile-tab="account"]') || null);
    };
    peopleButton();
    new MutationObserver(peopleButton).observe(document.body, { childList: true });
    // Before the storyboard's own bottom bar sees the tap.
    document.addEventListener('click', function (e) {
      if (!(e.target && e.target.closest && e.target.closest('#ppCrewMobileBtn'))) return;
      e.preventDefault(); e.stopPropagation();
      window.PPCrew.open();
    }, true);

    // Locations: everyone on the project sees them; planners change them.
    if (!window.PPLocations) window.PPLocations = { __lazy: true, open: later('locations', 'PPLocations', 'open'), show: later('locations', 'PPLocations', 'show'), addPhotos: later('locations', 'PPLocations', 'addPhotos'), hide: function () {}, refresh: function () {} };
    if (/^\/[^/]+\/locations\/?$/.test(path())) load('locations');
    var PIN_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>';
    var openLocations = function (e) { e.preventDefault(); e.stopPropagation(); window.PPLocations.open(); };
    var locationButtons = function () {
      var rail = document.getElementById('navShareBtn');
      if (rail && !document.getElementById('navLocationsBtn')) {
        var b = document.createElement('button');
        b.className = 'nav-item'; b.id = 'navLocationsBtn'; b.type = 'button';
        b.title = 'Locations: the script’s places, where they’re shot, scout photos';
        b.innerHTML = PIN_SVG + '<span>Locations</span>';
        // Always People, Budget, Locations, whichever script adds its button first (Budget goes right after People).
        var after = document.getElementById('navBudgetBtn') || rail;
        rail.parentNode.insertBefore(b, after.nextSibling);
        b.addEventListener('click', openLocations);
      }
      var nav = document.getElementById('mobileCompanionNav');
      if (nav && !document.getElementById('ppLocationsMobileBtn')) {
        var m = document.createElement('button');
        m.className = 'mobile-nav-btn'; m.id = 'ppLocationsMobileBtn'; m.type = 'button';
        m.setAttribute('aria-label', 'Locations'); m.title = 'Locations';
        m.innerHTML = PIN_SVG;
        var people = document.getElementById('ppCrewMobileBtn');
        nav.insertBefore(m, people ? people.nextSibling : nav.querySelector('[data-mobile-tab="account"]') || null);
      }
    };
    new MutationObserver(function () { if (document.getElementById('navShareBtn') && !document.getElementById('navLocationsBtn')) locationButtons(); if (document.getElementById('mobileCompanionNav') && !document.getElementById('ppLocationsMobileBtn')) locationButtons(); }).observe(document.body, { childList: true });
    locationButtons();
    document.addEventListener('click', function (e) {
      if (!(e.target && e.target.closest && e.target.closest('#ppLocationsMobileBtn'))) return;
      openLocations(e);
    }, true);

    // Prep: each department's looks, sets, props and mics before the day; continuity after it.
    if (!window.PPPrep) window.PPPrep = { __lazy: true, open: later('prep', 'PPPrep', 'open'), show: later('prep', 'PPPrep', 'show'), upload: later('prep', 'PPPrep', 'upload'), hide: function () {}, refresh: function () {} };
    if (/^\/[^/]+\/prep\/?$/.test(path())) load('prep');
    var HANGER_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 7a2 2 0 1 1 2-2"/><path d="M12 7v1.5L3 15a1.7 1.7 0 0 0 1 3h16a1.7 1.7 0 0 0 1-3l-9-6.5"/></svg>';
    var openPrep = function (e) { e.preventDefault(); e.stopPropagation(); window.PPPrep.open(); };
    var prepButtons = function () {
      var rail = document.getElementById('navShareBtn');
      if (rail && !document.getElementById('navPrepBtn')) {
        var b = document.createElement('button');
        b.className = 'nav-item'; b.id = 'navPrepBtn'; b.type = 'button';
        b.title = 'Prep: looks, sets, props, mics and continuity';
        b.innerHTML = HANGER_SVG + '<span>Prep</span>';
        // After Locations (or Budget, or People): the pre-production pages together.
        var after = document.getElementById('navLocationsBtn') || document.getElementById('navBudgetBtn') || rail;
        rail.parentNode.insertBefore(b, after.nextSibling);
        b.addEventListener('click', openPrep);
      }
      var nav = document.getElementById('mobileCompanionNav');
      if (nav && !document.getElementById('ppPrepMobileBtn')) {
        var m = document.createElement('button');
        m.className = 'mobile-nav-btn'; m.id = 'ppPrepMobileBtn'; m.type = 'button';
        m.setAttribute('aria-label', 'Prep'); m.title = 'Prep';
        m.innerHTML = HANGER_SVG;
        var loc = document.getElementById('ppLocationsMobileBtn');
        nav.insertBefore(m, loc ? loc.nextSibling : nav.querySelector('[data-mobile-tab="account"]') || null);
      }
    };
    new MutationObserver(function () { if ((document.getElementById('navShareBtn') && !document.getElementById('navPrepBtn')) || (document.getElementById('mobileCompanionNav') && !document.getElementById('ppPrepMobileBtn'))) prepButtons(); }).observe(document.body, { childList: true });
    prepButtons();
    document.addEventListener('click', function (e) {
      if (!(e.target && e.target.closest && e.target.closest('#ppPrepMobileBtn'))) return;
      openPrep(e);
    }, true);

    // The Script, on a phone a page in More, for the people the side bar's Script button is for (a script right, the level).
    var SCRIPT_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2h9l5 5v15H6z"/><path d="M14 2v6h6"/><path d="M9 12h6M9 16h6M9 20h4"/></svg>';
    var scriptShown = function () { var b = document.getElementById('navScriptBtn'); return !!b && getComputedStyle(b).display !== 'none'; };
    var scriptButton = function () {
      var nav = document.getElementById('mobileCompanionNav');
      if (!nav) return;
      var m = document.getElementById('ppScriptMobileBtn');
      if (!m) {
        m = document.createElement('button');
        m.className = 'mobile-nav-btn'; m.id = 'ppScriptMobileBtn'; m.type = 'button';
        m.setAttribute('aria-label', 'Script'); m.title = 'Script';
        m.innerHTML = SCRIPT_SVG;
        nav.insertBefore(m, document.getElementById('ppScheduleMobileBtn') || nav.querySelector('[data-mobile-tab="account"]') || null);
      }
      m.classList.toggle('pp-tab-hidden', !scriptShown());
    };
    new MutationObserver(function () { if (document.getElementById('mobileCompanionNav')) scriptButton(); }).observe(document.body, { childList: true, attributes: true, attributeFilter: ['class'] });
    scriptButton();
    document.addEventListener('click', function (e) {
      // The script right comes with the project: check it again whenever the phone bar is used (More lists what's shown).
      if (e.target && e.target.closest && e.target.closest('#mobileCompanionNav')) scriptButton();
      if (!(e.target && e.target.closest && e.target.closest('#ppScriptMobileBtn'))) return;
      var b = document.getElementById('navScriptBtn');
      if (b) { e.preventDefault(); b.click(); }
    }, true);

    // The Schedule: the side bar's Schedule button, and on a phone a page in More.
    if (!window.PPSchedule) window.PPSchedule = { __lazy: true, show: later('schedule', 'PPSchedule', 'show'), addDay: later('schedule', 'PPSchedule', 'addDay'), hide: function () {}, refresh: function () {}, open: function () { return false; } };
    if (/^\/[^/]+\/schedule\/?$/.test(path()) || /^\/storyboard\/[^/]+\/production\/?$/.test(path())) load('schedule');
    // Before the storyboard's own handler (it opened the board in a new tab).
    document.addEventListener('click', function (e) {
      if (!(e.target && e.target.closest && e.target.closest('#navProductionBtn, #ppScheduleMobileBtn'))) return;
      e.preventDefault(); e.stopImmediatePropagation();
      window.PPSchedule.show(true);
    }, true);
    // A link to this project's Schedule (the Overview, the calendar, the phone's Today card) opens it in place.
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.origin !== location.origin || !/^\/[^/]+\/schedule\/?$/.test(a.pathname) || !window.PPRoute) return;
      var st = window._sbState, mine = st && st.project && st.project.slug;
      if (!mine || window.PPRoute.idFor(window.PPRoute.keyOf(a.pathname)) !== mine) return;
      e.preventDefault();
      window.PPSchedule.show(true, new URLSearchParams(a.search).get('day') || '');
    });
    var CAL_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="2"/><path d="M8 3v4M16 3v4M3.5 10h17M8 14h3M8 17h3M13 14h3"/></svg>';
    var scheduleButton = function () {
      var nav = document.getElementById('mobileCompanionNav');
      if (!nav || document.getElementById('ppScheduleMobileBtn')) return;
      var m = document.createElement('button');
      m.className = 'mobile-nav-btn'; m.id = 'ppScheduleMobileBtn'; m.type = 'button';
      m.setAttribute('aria-label', 'Schedule'); m.title = 'Schedule';
      m.innerHTML = CAL_SVG;
      nav.insertBefore(m, document.getElementById('ppCrewMobileBtn') || nav.querySelector('[data-mobile-tab="account"]') || null);
    };
    scheduleButton();
    new MutationObserver(function () { if (document.getElementById('mobileCompanionNav') && !document.getElementById('ppScheduleMobileBtn')) scheduleButton(); }).observe(document.body, { childList: true });

    // Budget. Its button shows only to people who can spend or manage it.
    if (!window.PPBudget) window.PPBudget = { __lazy: true, open: later('budget', 'PPBudget', 'open'), show: later('budget', 'PPBudget', 'show'), log: later('budget', 'PPBudget', 'log'), hide: function () {}, refresh: function () {} };
    var BUDGET_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M7 9h10M7 13h6"/><path d="M15.5 15.5h2"/></svg>';
    var budgetMe = null;
    var budgetView = function () { return budgetMe && budgetMe.manage ? 'top' : 'mine'; };
    var openBudget = function (e) { e.preventDefault(); e.stopPropagation(); window.PPBudget.open(budgetView()); };
    var budgetButtons = function () {
      var rail = document.getElementById('navShareBtn');
      if (rail && !document.getElementById('navBudgetBtn')) {
        var b = document.createElement('button');
        b.className = 'nav-item'; b.id = 'navBudgetBtn'; b.type = 'button';
        b.title = budgetMe.manage ? 'The budget: top sheet, costs, receipts and reports' : 'Log your expenses';
        b.innerHTML = BUDGET_SVG + '<span>' + (budgetMe.manage ? 'Budget' : 'Expenses') + '</span>';
        rail.parentNode.insertBefore(b, rail.nextSibling);
        b.addEventListener('click', openBudget);
      }
      var nav = document.getElementById('mobileCompanionNav');
      if (nav && !document.getElementById('ppBudgetMobileBtn')) {
        var m = document.createElement('button');
        m.className = 'mobile-nav-btn'; m.id = 'ppBudgetMobileBtn'; m.type = 'button';
        m.setAttribute('aria-label', budgetMe.manage ? 'Budget' : 'Expenses'); m.title = budgetMe.manage ? 'Budget' : 'Expenses';
        m.innerHTML = BUDGET_SVG;
        var people = document.getElementById('ppCrewMobileBtn');
        nav.insertBefore(m, people ? people.nextSibling : nav.querySelector('[data-mobile-tab="account"]') || null);
      }
    };
    // The phone button: before the storyboard's own bottom bar sees it. Once
    // pp-budget.js is in, its own handler takes this over.
    document.addEventListener('click', function (e) {
      if (!window.PPBudget.__lazy || !(e.target && e.target.closest && e.target.closest('#ppBudgetMobileBtn'))) return;
      openBudget(e);
    }, true);
    // Expenses logged with no signal on an earlier visit send once pp-budget.js runs.
    var outboxWaiting = function () {
      return new Promise(function (done) {
        if (!window.indexedDB) return done(false);
        var r;
        try { r = indexedDB.open('pp-budget-outbox', 1); } catch (_e) { return done(false); }
        // As pp-budget.js creates it, so its own open finds the store.
        r.onupgradeneeded = function () { r.result.createObjectStore('costs', { keyPath: 'id' }); };
        r.onerror = function () { done(false); };
        r.onsuccess = function () {
          var db = r.result;
          try { var c = db.transaction('costs', 'readonly').objectStore('costs').count(); c.onsuccess = function () { db.close(); done(c.result > 0); }; c.onerror = function () { db.close(); done(false); }; } catch (_e) { db.close(); done(false); }
        };
      });
    };
    var budgetStart = function () {
      var st = window._sbState, pid = st && st.project && st.project.slug;
      if (/^\/[^/]+\/budget(\/.*)?$/.test(path())) { load('budget'); return; }
      fetch('/v1/budget/' + encodeURIComponent(pid) + '/me', { credentials: 'include' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (me) {
          if (!me || !(me.spend || me.manage)) return;
          budgetMe = me;
          budgetButtons();
          new MutationObserver(function () { if (!document.getElementById('ppBudgetMobileBtn') && document.getElementById('mobileCompanionNav')) budgetButtons(); }).observe(document.body, { childList: true });
          return outboxWaiting().then(function (any) { if (any) load('budget'); });
        })
        .catch(function () { /* not signed in, or no project: nothing to show */ });
    };
    var wait = setInterval(function () {
      if (document.getElementById('navRail') && window._sbState && window._sbState.project) { clearInterval(wait); budgetStart(); }
    }, 200);
    setTimeout(function () { clearInterval(wait); }, 30000);

    // Back or forward to People, Locations, the Schedule or Budget before their file is in: load it,
    // then hand it the same history step.
    window.addEventListener('popstate', function () {
      var key = /^\/[^/]+\/people(\/|$)/.test(location.pathname) ? 'crew' : /^\/[^/]+\/budget(\/|$)/.test(location.pathname) ? 'budget' : /^\/[^/]+\/locations\/?$/.test(location.pathname) ? 'locations' : /^\/[^/]+\/prep\/?$/.test(location.pathname) ? 'prep' : /^\/[^/]+\/schedule\/?$/.test(location.pathname) ? 'schedule' : '';
      if (!key || bundles[key]) return;
      load(key).then(function () { window.dispatchEvent(new PopStateEvent('popstate', { state: history.state })); });
    });

    // Script, and the Shot Editor's script context. The storyboard calls
    // _sbOpenScriptWorkspace when Script opens; script-handler.js replaces it.
    var unstyled = document.createElement('style');
    unstyled.textContent = '#appScreen.in-script{visibility:hidden}';
    document.head.appendChild(unstyled);
    var script = function () { return load('script').then(function () { unstyled.remove(); }, function (e) { unstyled.remove(); throw e; }); };
    var stub = function () {
      script().then(function () { if (window._sbOpenScriptWorkspace !== stub) window._sbOpenScriptWorkspace(); }, failed);
    };
    if (typeof window._sbOpenScriptWorkspace !== 'function') window._sbOpenScriptWorkspace = stub;
    // Set Pieces (split out of storyboard.js): the storyboard opens it through
    // these two, which sb-set-pieces.js replaces.
    ['_sbOpenSetPiecesWorkspace', '_handleSetPiecesRoute'].forEach(function (name) {
      if (typeof window[name] === 'function') return;
      var stand = window[name] = function () {
        var args = arguments;
        load('setpieces').then(function () { if (window[name] !== stand) window[name].apply(window, args); }, failed);
      };
    });

    prefetchLater(function () { return ['script', 'crew', 'setpieces', 'schedule', 'scout'].concat(budgetMe ? ['budget'] : []); });

    var editor = document.getElementById('view-editor');
    if (editor) {
      var watch = new MutationObserver(function () { if (!editor.classList.contains('hidden')) { watch.disconnect(); script().catch(function () {}); } });
      watch.observe(editor, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // ── The production board ──────────────────────────────────────────────
  var launch = ['prodCallSheetBtn', 'prodMobileCallSheetBtn'].map(function (id) { return document.getElementById(id); }).filter(Boolean);
  if (launch.length) {
    if (!window.ProductionCallSheets) window.ProductionCallSheets = { __lazy: true, openReview: later('callsheets', 'ProductionCallSheets', 'openReview'), openCall: later('callsheets', 'ProductionCallSheets', 'openCall') };
    // The buttons work once the file is in (it wires them itself): until
    // then, a press loads it and is passed on.
    launch.forEach(function (b) {
      b.addEventListener('click', function (e) {
        // Once the file has run, its own handler takes the press. Still on its
        // way (wide screens start it early): wait for it, then pass it on.
        if (!window.ProductionCallSheets.__lazy) return;
        e.preventDefault(); e.stopImmediatePropagation();
        load('callsheets').then(function () { b.click(); }, failed);
      }, true);
    });
    // Someone who manages days, on a wide screen, sees call sheets waiting for
    // an update without opening anything: load it once the board is up.
    var since = Date.now(), check = setInterval(function () {
      // (The board only has the button for people who manage days; production.js hides it on board links.)
      var shown = !launch[0].classList.contains('hidden');
      if (bundles.callsheets || Date.now() - since > 30000) return clearInterval(check);
      if (shown && document.readyState === 'complete' && !matchMedia('(max-width:800px)').matches) { clearInterval(check); load('callsheets'); }
    }, 1000);
  }
})();
